import { useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import { useLanguage } from "@/contexts/LanguageContext";
import { useAuth } from "@/contexts/AuthContext";
import FirestoreService from "@/services/firestore";

export const useIPMAStationActions = () => {
  const { toast } = useToast();
  const { t } = useLanguage();
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleArchive = async (id: string) => {
    try {
      setIsLoading(true);
      // Use FirestoreService directly for better consistency with existing code
      await FirestoreService.request(
        "archive-ipmaStation",
        { documentId: id },
        "setup_ipmaStations",
        user?.uid
      );
      toast({
        title: t("success"),
        description: t("ipmaStations.archived"),
      });
    } catch (error) {
      console.error("Error archiving IPMA station:", error);
      toast({
        title: t("error"),
        description: t("ipmaStations.errors.archiveError"),
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleRestore = async (id: string) => {
    try {
      setIsLoading(true);
      await FirestoreService.request(
        "restore-ipmaStation",
        { documentId: id },
        "setup_ipmaStations",
        user?.uid
      );
      toast({
        title: t("success"),
        description: t("ipmaStations.restored"),
      });
    } catch (error) {
      console.error("Error restoring IPMA station:", error);
      toast({
        title: t("error"),
        description: t("ipmaStations.errors.restoreError"),
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    handleArchive,
    handleRestore,
    isLoading,
  };
}; 